import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ResponseDto } from '../../../shared/dtos/response.dto';
import { ConfigurationOptionsResponseDto } from '../dtos/confiuration-options.dto';
import { TopconConfigurationResponseDto } from '../dtos/partner-configuration.dto';
import { PartnerCUResponseDto, PartnerCUDto } from '../dtos/partner-cu.dto';
import { AddServiceLevelConfigurationResponseDto, SavedServiceLevelConfiguration, UnsavedServiceLevelConfiguration } from '../dtos/service-level-config.dto';
import { TestActivationConfig } from '../dtos/test-activation-config.dto';

@Injectable({
    providedIn: 'root'
})
export class TopconConfigurationService {
    private readonly TOPCON_GET_ENDPOINT = environment.outgoingRequestAPI + 'TopconConfiguration';
    private readonly CONFIGURATION_OPTIONS_GET_ENDPOINT = environment.outgoingRequestAPI + 'Configuration/selection?isTopconPartner=true';
    private readonly TEST_ACTIVATION_POST_ENDPOINT = environment.outgoingRequestAPI + 'TopconConfiguration/testactivation/config';
    private readonly PARTNER_GET_ENDPOINT = environment.outgoingRequestAPI + 'Configuration/partners?isTopconPartner=true';
    private readonly PARTNER_POST_ENDPOINT = environment.outgoingRequestAPI + 'Configuration/partner';

    public constructor(
        private http: HttpClient
    ) { }

    public getTopconPartners(): Observable<PartnerCUResponseDto> {
        return this.http.get<PartnerCUResponseDto>(this.PARTNER_GET_ENDPOINT);
    }

    public updatePartnerConfiguration(data: PartnerCUDto): Observable<ResponseDto> {
        return this.http.put<ResponseDto>(this.PARTNER_POST_ENDPOINT, {
            configurationData: data
        });
    }

    public getTopconConfigurationByPartner(organizationId: number): Observable<TopconConfigurationResponseDto> {
        return this.http.get<TopconConfigurationResponseDto>(this.TOPCON_GET_ENDPOINT + '/' + organizationId);
    }

    public getConfigurationOptions(): Observable<ConfigurationOptionsResponseDto> {
        return this.http.get<ConfigurationOptionsResponseDto>(this.CONFIGURATION_OPTIONS_GET_ENDPOINT);
    }

    public deleteServiceLevelConfiguration(id: number): Observable<ResponseDto> {
        return this.http.delete<ResponseDto>(this.TOPCON_GET_ENDPOINT + '/serviceoffer/' + id);
    }

    public deleteServiceLevelConfigurationByServiceLevel(serviceLevelId: number): Observable<ResponseDto> {
        return this.http.delete<ResponseDto>(this.TOPCON_GET_ENDPOINT + '/serviceoffer/all/' + serviceLevelId);
    }

    public addServiceLevelConfiguration(data: UnsavedServiceLevelConfiguration): Observable<AddServiceLevelConfigurationResponseDto> {
        return this.http.post<AddServiceLevelConfigurationResponseDto>(this.TOPCON_GET_ENDPOINT + '/serviceoffer', {
            configurationData: data
        });
    }

    public updateServiceLevelConfiguration(data: SavedServiceLevelConfiguration): Observable<ResponseDto> {
        return this.http.put<ResponseDto>(this.TOPCON_GET_ENDPOINT + '/serviceoffer', {
            configurationData: data
        });
    }

    public addTestActivationConfig(testactivation: TestActivationConfig): Observable<ResponseDto> {
        return this.http.post<ResponseDto>(this.TEST_ACTIVATION_POST_ENDPOINT, {
            configurationData: testactivation
        });
    }

    public updateTestActivationConfig(testactivation: TestActivationConfig): Observable<ResponseDto> {
        return this.http.put<ResponseDto>(this.TEST_ACTIVATION_POST_ENDPOINT, {
            configurationData: testactivation
        });
    }

    public deleteTestActivationConfig(id: number): Observable<ResponseDto> {
        return this.http.delete<ResponseDto>(this.TEST_ACTIVATION_POST_ENDPOINT + '/' + id);
    }
}
